import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import style from './style'
import propTypes from './prop'
import { withStyles, CircularProgress, Grid } from '@material-ui/core'

// Requests that finish sooner don't dim the screen (no flash on page loads).
const SHOW_DELAY = 400

/**
 * Full-screen loading layer while a request runs. It blocks clicks right away
 * but stays clear; the dim and spinner fade in only if the request is slow.
 */
const Preloader = ({ classes, ...props }) => {
  const { process } = props
  const { working } = process
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!working) {
      setVisible(false)
      return undefined
    }
    const timer = setTimeout(() => setVisible(true), SHOW_DELAY)
    return () => clearTimeout(timer)
  }, [working])

  if (!working) {
    return null
  }
  return (
    <Grid
      className={classNames(classes.root, visible && classes.visible)}
      container
      alignContent="center"
      alignItems="center"
    >
      {visible && (
        <Grid item xs={12} className={classes.progressWrapper}>
          <CircularProgress color="primary" />
        </Grid>
      )}
    </Grid>
  )
}

Preloader.propTypes = propTypes

export default withStyles(style)(Preloader)
